import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { theme, transientOptions } from "shared/lib/styles";

import type { HeaderFeaturesLogoTextLinkSize } from "scmp-app/components/header/features/logo-text-link";
import { responsiveStyles } from "scmp-app/components/header/features/styles";
import type { ResponsiveStyledProps } from "scmp-app/components/header/features/types";
import IconLogoText from "scmp-app/components/header/icon-logo-with-text.svg";

export const Container = styled.div<ResponsiveStyledProps>`
  ${responsiveStyles}
`;

export const StyledLogoLink = styled(BaseLink)`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
`;

export type StyledScmpLogoTextProps = {
  $size?: HeaderFeaturesLogoTextLinkSize;
};
export const StyledScmpLogoText = styled(IconLogoText, {
  ...transientOptions,
})<StyledScmpLogoTextProps>`
  /* --- Default Size --- */
  inline-size: 207px;
  block-size: 22px;

  ${theme.breakpoints.up("desktop")} {
    inline-size: 282px;
    block-size: 30px;
  }

  /* --- Small Size --- */
  ${({ $size }) =>
    $size === "small" &&
    css`
      ${theme.breakpoints.up("desktop")} {
        inline-size: 207px;
        block-size: 22px;
      }
    `}

  /* --- Large Size --- */
  ${({ $size }) =>
    $size === "large" &&
    css`
      ${theme.breakpoints.up("tablet")} {
        inline-size: 330px;
        block-size: 34.3px;
      }
      ${theme.breakpoints.up("desktop")} {
        inline-size: 539px;
        block-size: 56px;
      }
    `}
`;
